<template>
  <b-row>
    <b-col>
      <b-card :class="{ open: visibleBody }" style="margin:0">
        <b-card-header
          :class="{ collapsed: !visibleBody }"
          role="tab"
          @click="onVisibleBody()"
          style="background-color: #0080C9; color: white; font:45px; padding: 15px; cursor: pointer;"
        >
          <span class="lead collapse-title"><strong>RECETA</strong></span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >

          <b-card-body style="margin:0; border:1px solid #2980b9;">

            <!-- <span>{{ tokenReceta }}</span> -->

            <div 
              class="row d-flex align-items-center mt-1" 
              style="position: relative;"
            >
              <CommentEditor
                v-if="isAuditoria"
                field="receta"
                :comentarios="comentarios"
              />
            </div>

            <RecetaList
              onlyView
              v-if="receta"
              v-model="receta.medicamentos"
            />

            <EmptyResults 
              v-if="!receta"
              :message="'No existe una receta para mostrar.'"
            />
          </b-card-body>

        </b-collapse>
      </b-card>
    </b-col>

  </b-row>
</template>

<script>
import { RecetaList } from '@/views/farmacia/components';
import { recetaService } from '@/views/farmacia/services';
import { EmptyResults } from '@/shared/components';

import CommentEditor from '../CommentEditor/CommentEditor.vue';

export default {

  name: "AtencionReceta",

  props: {

    tokenAtencion:{
      type: String,
      required: true
    },

    isAuditoria: {
      type: Boolean,
      default: false
    },
  },

  components: {
    RecetaList,
    EmptyResults,
    CommentEditor
  },

  data() {
    return {
      visibleBody: false,
      receta: null,

      comentarios:{}
    }
  },


  created() {
    this.onGetData();
  },

  methods: {

    onVisibleBody() {
      this.visibleBody = !this.visibleBody
    },


    async onGetData(){
      const data = await recetaService.getByAtencion(this.tokenAtencion);
      console.log('la receta', data);
      
      if (!data) return;
      this.receta = data;

      
    },

    onSaveComment(field){
      this.$set(this.comentarios, field, { edit:true, text:null });
      // console.log('add', this.comentarios)
    },

    onRemoveComment(field){
      this.$set(this.comentarios, field, null);
      // console.log('remove', this.comentarios)
    }
    
  },

  computed: {

    tipoConsultaText() {
      return this.anamnesis?.tipoConsulta?.descripcion;
    }
  },

  watch: {

    tokenAnamnesis: {
      deep: true,
      handler(newValue) {
        console.log('token anamnesis', newValue)
        this.onGetData();
      }
    },

    comentarios:{
      deep: true,
      handler(newValue) {
        const comentario = newValue.receta || null;
        this.$store.commit("setComentarios", { receta: comentario });
        
        this.$store.commit("setRevisiones", {
          tokenAtencion: this.tokenAtencion,
          data: { receta: comentario }
        });
      }
    }
  }

  
};
</script>
